import {
  CONTAINER_ARGS,
  FLEX_ARGS,
  GRID_ARGS,
  Metadata,
  pick,
} from '../../../../utils/spds/metadata';
import Super from '../../core/container.gjs';

const FLEX_ONLY_ARG_NAMES = Object.keys(FLEX_ARGS.meta).filter(name => !(name in GRID_ARGS.meta));

const METADATA = Metadata.define({
  description: `
Grid layout component

A convenience wrapper around \`Spds::Core::Container\` that renders a CSS Grid layout. It sets \`@grid={{true}}\` on the
underlying container, enabling the grid-specific arguments.

Grid suits two-dimensional layouts that need precise control over both rows and columns, or named grid areas for complex,
responsive layouts. For common cases, \`@columns\`, \`@rows\`, \`@areas\`, \`@area\` and \`@autoFlow\` are shorthands for
their full \`@grid*\` counterparts.
  `,
  extends: [pick(CONTAINER_ARGS, [{ name: 'grid', default: true }])],
  name: 'Grid Container',
  // Flex direction and flex-only args never apply to a grid element.
  omits: ['column', 'flexbox', 'reverse', ...FLEX_ONLY_ARG_NAMES],
});

export default class SpdsLayoutGridContainer extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
}

export const LAYOUT_GRID_CONTAINER_METADATA = SpdsLayoutGridContainer.metadata;
